import React from 'react'
import { CircularProgress } from '@mui/material'
import './TopQuestionsHistoricalDataLoader.scss'

type TopQuestionsHistoricalDataLoaderProps = {
  message: string
}

export const TopQuestionsHistoricalDataLoader: React.FC<TopQuestionsHistoricalDataLoaderProps> = ({ message }) => {

  return <div className={'TopQuestionsHistoricalDataLoader-wrapper'}>
    <CircularProgress />
    {message}
  </div>
}
